import { Outlet, useMatches } from "react-router";
import { SidebarInset, SidebarProvider, SidebarTrigger, useSidebar } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import type { CustomRouteHandle } from "@/types/router";
import { cx } from "class-variance-authority";
import { AppBreadcrumbs } from "./AppBreadcrumbs";
import { CommandPalette } from "@/components/CommandPalette/CommandPalette";

const DashboardLayout = () => {
	const matches = useMatches();
	const currentHandle = matches.slice(-1)[0]?.handle as CustomRouteHandle | undefined;
	const isFull = currentHandle?.layout === "full";

	const { open, isMobile } = useSidebar();

	return (
		<div className={cx("flex min-h-screen w-full bg-primary p-2 gap-0", isFull ? "max-h-screen" : "")}>
			<CommandPalette />
			<AppSidebar />

			{!isMobile && (
				<div className={cx("relative", open ? "w-0" : "w-7")}>
					<SidebarTrigger
						className={cx(
							"text-white rounded flex items-center justify-center z-50 transition-all duration-300",
							"fixed top-[18px]",
							open ? "left-56" : "left-[10px]",
						)}
					/>
				</div>
			)}

			<SidebarInset className="flex-1 mb-5 min-w-0 overflow-x-hidden rounded-xl">
				<div
					className={cx(
						"min-h-full bg-white shadow rounded-xl transition-all duration-300",
						isFull ? "overflow-hidden" : "p-4",
					)}
				>
					{!isFull && (
						<div className="flex items-center gap-2">
							{isMobile && <SidebarTrigger className="h-7 w-7 shrink-0" />}
							<AppBreadcrumbs />
						</div>
					)}

					<Outlet />
				</div>
			</SidebarInset>
		</div>
	);
};

export const Dashboard = () => (
	<SidebarProvider>
		<DashboardLayout />
	</SidebarProvider>
);
